

import React, { useEffect, useState } from 'react';
import {
  Box, Card, CardMedia, CardContent, Typography, IconButton,
  useMediaQuery, useTheme, CircularProgress, Dialog, DialogContent
} from '@mui/material';

import { useNavigate , useLocation} from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Link } from 'react-router-dom';
import FormsBottomNavbar from './../Post Module/FormsBottomNavbar';
import property_pincode_new from "./../../../Images/property_pincode_new.png";
import Elevationnew from "./../../../Assets/Elevations.png";

import axios from 'axios';
import { BASE_URL } from './../../Api/ApiUrls';
import { toast } from 'react-toastify';

const API_BASE_URL = `${BASE_URL}`;
const IMAGE_BASE_URL = `${API_BASE_URL}/construction-content`;

const chunkArray = (array, chunkSize) => {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};

const Elevations = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [loading, setLoading] = useState(true);
  const [plans, setPlans] = useState([]);
  const [value, setValue] = useState('construction');
  const [selectedImage, setSelectedImage] = useState(null);
    const [selectedTitle, setSelectedTitle] = useState(null);
const [openModal, setOpenModal] = useState(false);
   const location = useLocation();

const handleImageClick = (imageUrl, title) => {
  setSelectedImage(imageUrl);
  setSelectedTitle(title);
  setOpenModal(true);
};


const handleCloseModal = () => {
  setOpenModal(false);
  setSelectedImage(null);
  setSelectedTitle(null);
};


  useEffect(() => {
    const fetchPlans = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${IMAGE_BASE_URL}/`);
        // Filter plans where category_id is 3 (for Elevation Plans)
        const elevationPlans = response.data.filter(plan => plan.category_id == 3);
        setPlans(elevationPlans);
      } catch (error) {
        console.error("Error fetching elevation plans:", error);
        toast.error("Failed to fetch elevation plans. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

  const rows = chunkArray(plans, 2);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

return (
    <>
      {/* Fixed Header Section */}
      <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        bgcolor: 'background.paper',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        {/* Top Navigation Bar */}
        <Box display="flex" alignItems="center" justifyContent="space-between" p={1} sx={{
          background: 'black',
          borderBottom: '1px solid rgba(0,0,0,0.08)'
        }}>
          {/* Back Arrow - Left Side */}
          <IconButton
            onClick={() => navigate(-1)}
            sx={{
              color: 'white',
              '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
            }}
          >
            <ArrowBackIosIcon />
          </IconButton>
          
          {/* Center Text - "PROPERTY PINCODER" */}
          <Typography variant="h7" component="div" sx={{ 
            color: 'white',
            fontWeight: 'bold',
            flexGrow: 1,
            textAlign: 'left'
          }}>
             PROPERTY PINCODER
          </Typography>
          
          {/* Right Side Logo */}
          <Box sx={{ 
            width: 90,
            boxShadow: '0px 4px 10px rgba(255, 255, 255, 0.6)',
            height: 50,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <img 
              src={property_pincode_new} 
              alt="property_pincode_new Logo" 
              style={{ 
                maxWidth: '100%', 
                maxHeight: '100%',
                objectFit: 'contain'
              }}
            />
          </Box>
        </Box>
      
        {/* Construction/Interior Navigation */}
        <Box sx={{
          padding: isMobile ? 1 : 0.5,
          display: 'flex',
          justifyContent: 'space-between',
          boxShadow: '0 5px 10px rgba(0,0,0,0.1)',
        }}>
          {/* Construction - Active */}
          <Box
            component={Link}
            to="/constructions"
            sx={{
              flex: 1,
              textAlign: 'center',
              py: 2,
              textDecoration: 'none',
              position: 'relative',
              background: `
                linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
                url(${Elevationnew})
              `,
              backgroundBlendMode: 'overlay',
              borderRight: '1px solid rgba(0,0,0,0.1)',
              borderTopLeftRadius: '30px',
              boxShadow: `
                inset 0 0 15px rgba(0,0,0,0.2),
                0 4px 10px rgba(0,0,0,0.15)
              `,
              transform: 'scale(1.02)',
              transition: 'all 0.3s ease',
              zIndex: 1,
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: `
                  inset 0 0 20px rgba(0,0,0,0.15),
                  0 5px 12px rgba(0,0,0,0.18)
                `,
                '&::after': {
                  width: '70%',
                  backgroundColor: '#333333',
                }
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '70%',
                height: '3px',
                backgroundColor: '#333333',
                borderRadius: '3px',
                transition: 'all 0.3s ease',
              }
            }}>
            <Typography variant={isMobile ? "h6" : "h5"} component="div" sx={{
              fontWeight: 800,
              color: '#333333',
              textShadow: '0 1px 3px rgba(255,255,255,0.5)',
              fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
              transform: 'scale(1.05)',
              transition: 'transform 0.3s ease',
            }}>
              Constructions
            </Typography>
          </Box>
        
          {/* Interiors - Inactive */}
          <Box
            component={Link}
            to="/interiors"
            sx={{
              flex: 1,
              textAlign: 'center',
              py: 2,
              position: 'relative',
              background: `
                linear-gradient(145deg, rgb(22, 22, 22), rgb(15, 15, 15)),
                url('/construction5.png')
              `,
              backgroundBlendMode: 'overlay',
              textDecoration: 'none',
              borderBottomRightRadius: '30px',
              boxShadow: `
                inset 0 0 15px rgba(0,0,0,0.2),
                0 2px 5px rgba(0,0,0,0.1)
              `,
              transform: 'scale(0.98)',
              transition: 'all 0.3s ease',
              '&:hover': {
                background: `
                  linear-gradient(145deg, rgb(35, 35, 35), rgb(25, 25, 25)),
                  url('/construction5.png')
                `,
                transform: 'scale(1)',
                boxShadow: `
                  inset 0 0 20px rgba(0,0,0,0.3),
                  0 3px 8px rgba(0,0,0,0.2)
                `,
                '&::after': {
                  width: '70%',
                  backgroundColor: 'rgba(255,255,255,0.9)',
                }
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '0%',
                height: '3px',
                backgroundColor: 'transparent',
                borderRadius: '3px',
                transition: 'all 0.3s ease',
              }
            }}
          >
            <Typography variant={isMobile ? "h6" : "h5"} component="div" sx={{
              fontWeight: 700,
              color: 'rgba(255,255,255,0.9)',
              letterSpacing: '1px',
              textShadow: '0 1px 5px rgba(0,0,0,0.7)',
              fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
              transform: 'scale(1)',
              transition: 'transform 0.3s ease',
            }}>
              Interiors
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{ 
        pt: isMobile ? '150px' : '110px', 
        minHeight: '100vh',
        backgroundColor: '#e7dbc9'
      }}>
        {/* Page Title */}
        <Typography
          variant="h5"
          align="center"
          fontWeight="bold"
          sx={{
            fontSize: isMobile ? '1.5rem' : '2rem',
            mb: 2
          }}
        >
          Elevations
        </Typography>

        {/* Content Cards */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: 2, 
          px: 2,
          pb: 15
        }}>
          {rows.map((row, rowIndex) => (
            <Box
              key={rowIndex}
              display="flex"
              gap={2}
            >
              {row.map((item) => (
                <Card
                  key={item.content_id}
                  sx={{ 
                    flex: 1,
                    borderRadius: 2,
                    boxShadow: 3,
                    height: '160px',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      transition: 'transform 0.3s ease'
                    }
                  }}
                >
                  <CardMedia
                    component="img"
                    height="120"
                    image={`${API_BASE_URL}${item.image}`}
                    alt={item.content}
                    sx={{ objectFit: 'cover', cursor: 'pointer' }}
                    onClick={() => handleImageClick(`${API_BASE_URL}${item.image}`, item.content)}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = `${API_BASE_URL}/media/default.jpg`;
                    }}
                  />
                  <CardContent sx={{ padding: '8px' }}>
                    <Typography variant="subtitle1" align="center" fontWeight="bold">
                      {item.content}
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>
          ))}
        </Box>

        <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
          <DialogContent sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom textAlign="center">{selectedTitle}</Typography>
            <img
              src={selectedImage}
              alt="Selected Elevation"
              style={{ width: '100%', height: 'auto' }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `${API_BASE_URL}/media/default.jpg`;
              }}
            />
          </DialogContent>
        </Dialog>
      </Box>

      <FormsBottomNavbar />
    </>
  );
};

export default Elevations;